import ConfirmPQ from './container/ConfirmPQ';

export default ConfirmPQ;



// WEBPACK FOOTER //
// ./src/views/ConfirmPQ/index.js